import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import { css } from "styled-components";

if (accountMessagesStyles.messageFilter) {
    accountMessagesStyles.messageFilter.radioButton = {
        css: css`
            margin-top: 10px;
            margin-left: 1.5em;
        `,
    };
}
